import React from "react";

interface StatCardProps {
  title: string;
  value: string;
  change?: number | null;
  subtitle?: string;
  changeLabel?: string;
  icon?: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  subtitle = "vs. previous period",
  changeLabel = "",
  icon,
}) => {
  // Determine if change is positive, negative, or neutral
  const changeColor = !change
    ? ""
    : change > 0
      ? "text-green-600 dark:text-green-400"
      : "text-red-600 dark:text-red-400";

  // Format change percentage
  const formattedChange =
    change !== null && change !== undefined
      ? `${change > 0 ? "+" : ""}${change.toFixed(1)}%`
      : null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400">
          {title}
        </h3>
        {icon && <div className="text-gray-400 dark:text-gray-500">{icon}</div>}
      </div>

      <div className="mt-2">
        <p className="text-2xl font-bold text-gray-900 dark:text-white">
          {value}
        </p>

        {formattedChange && (
          <div className="mt-1 flex items-center text-sm">
            <span className={`font-medium ${changeColor}`}>
              {formattedChange}
            </span>
            <span className="text-gray-500 dark:text-gray-400 ml-1">
              {subtitle}
            </span>
          </div>
        )}

        {changeLabel && !formattedChange && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {changeLabel}
          </p>
        )}
      </div>
    </div>
  );
};

export default StatCard;
